// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UfQg","top":"styles_top__16j_M"};